<template>
    <div class="pmis-presentation-container">
        <PmisPresentation :name="menuFor" :presentationData="presentationData" :idx="idx"></PmisPresentation>
        <!--        <PmisPresentationMenu :name="menuFor" :presentationMenu="presentationMenu"></PmisPresentationMenu>-->
        <PmisInfoFooterContainer :edit="false" :name="name" :idx="idx" :categories="presentationData.categories"></PmisInfoFooterContainer>
    </div>
</template>

<script>
    // import {presentation} from "./presentation";
    import presentation from "./../data/presentation";
    import PmisPresentation from "./PmisPresentation";
    // import PmisPresentationMenu from "./PmisPresentationMenu";
    import PmisInfoFooterContainer from "./PmisInfoFooterContainer";

    export default {
        name: "PmisPresentationContainer",
        // components: {PmisPresentationMenu, PmisInfoFooterContainer, PmisPresentation},
        components: {PmisInfoFooterContainer, PmisPresentation},
        props: {
            name: String,
            idx: Number
        },
        computed: {
            presentationData() {
                if(!presentation.hasOwnProperty(this.name))
                    console.log(localStorage.getItem('new_solution'));
                return presentation.hasOwnProperty(this.name) ? presentation[this.name] : JSON.parse(localStorage.getItem('new_solution'))[0];
            },
            // presentationMenu() {
            //     return presentation[this.name].menu;
            // },
            menuFor() {
                console.log(this.name);
                return this.name;
            }
        }
    }
</script>

<style lang="scss" scoped>
</style>
